import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';
import { useFormState } from 'react-final-form';

import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

import { supportArticles } from './constants';
import ArticleLink from './ArticleLink/ArticleLink';
import './SupportArticles.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function SupportArticles() {
  const { tr } = useTranslation();
  const [showArticles, setShowArticles] = useState(true);
  const itemsLength = useSelector(state => state.search?.itemsLength);
  const { values } = useFormState();

  useEffect(() => {
    if (!itemsLength || !values.searchStr) setShowArticles(true);
    else setShowArticles(false);
  }, [values.searchStr, itemsLength]);

  const toggleShowArticles = useCallback(() => setShowArticles(state => !state), []);

  return (
    <div className="SupportArticles px-4 py-2">
      <div className="mb-2">
        <WpButton variant="tertiary" onClick={toggleShowArticles}>
          <WpIcon name={showArticles ? 'chevron-down' : 'chevron-right'} />
          {tr('perform.search.support_articles.toggle_button')}
        </WpButton>
      </div>
      <Collapse isOpen={showArticles}>
        {supportArticles.map(article => (
          <ArticleLink
            key={article.url}
            {...article}
            title={tr(`perform.search.support_articles.${article.key}.title`)}
            description={tr(`perform.search.support_articles.${article.key}.description`)}
          />
        ))}
      </Collapse>
    </div>
  );
}

export default SupportArticles;
